import React, { useEffect, useState } from "react";
import {
  Col,
  Form,
  Input,
  Row,
  Table,
  message,
  Button,
  Select,
  Checkbox,
  InputNumber,
  Typography,
  Popconfirm,
  Modal,
} from "antd";

import { useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import HandleSearch from "../../utils/CommonSearchComponent";
import APICaller from "../../utils/APICaller";
import useCurrentPath, {
  paginationOptions,
  sortData,
} from "../../components/Constants";
import { store } from "../../store";
import CustomLoader from "../../components/CustomLoader";

const EditableCell = ({
  editing,
  dataIndex,
  title,
  inputType,
  record,
  index,
  children,
  departments,
  expenseCategories,
  ...restProps
}) => {
  let inputNode;
  if (dataIndex === "departmentID") {
    inputNode = (
      <Select
        showSearch
        options={departments}
        filterOption={(input, option) =>
          option.label.toLowerCase().includes(input.toLowerCase())
        }
      />
    );
  } else if (dataIndex === "expenseCatID") {
    inputNode = (
      <Select
        showSearch
        options={expenseCategories}
        filterOption={(input, option) =>
          option.label.toLowerCase().includes(input.toLowerCase())
        }
      />
    );
  } else if (dataIndex === "status") {
    inputNode = (
      <Select
        showSearch
        options={[
          { label: "Active", value: "ACTIVE" },
          { label: "Inactive", value: "INACTIVE" },
        ]}
        filterOption={(input, option) =>
          option.label.toLowerCase().includes(input.toLowerCase())
        }
      />
    );
  } else {
    inputNode = inputType === "number" ? <InputNumber /> : <Input />;
  }
  return (
    <td {...restProps}>
      {editing ? (
        <Form.Item
          name={dataIndex}
          style={{
            margin: 0,
          }}
          rules={[
            {
              required: true,
              message: `Please Input ${title}!`,
            },
          ]}
        >
          {inputNode}
        </Form.Item>
      ) : (
        children
      )}
    </td>
  );
};

const PendingUserConfiguration = () => {
  const location = useLocation();
  const currentPath = useCurrentPath();

  const [tableForm] = Form.useForm();

  //Search Filter
  const { Search } = Input;
  const [searchText, setSearchText] = useState("");

  let storeRole = useSelector((state) => state.auth.role);

  let storeToken = useSelector((state) => state.auth.accessToken);

  let storeLIUId = useSelector((state) => state.auth.lIUId);

  const storeAccessTokenExpiresOn = useSelector(
    (state) => state.auth.accessTokenExpiresOn,
  );
  const [storeList, setStoreList] = useState([]);
  const storePagination = useSelector((state) => state.auth.pagination);
  const storeTotalCount = useSelector((state) => state.auth.totalCount);

  const [pagination, setPagination] = useState({ current: 1, pageSize: 20 });
  const [list, setList] = useState([]),
    [departments, setDepartments] = useState([]);
  const [showLoader, setShowLoader] = useState(false);

  const [data, setData] = useState([]);
  const [editingKey, setEditingKey] = useState("");
  const [expenseCategories, setExpenseCategories] = useState([]);

  const isEditing = (record) => record.key === editingKey;

  const edit = (record) => {
    tableForm.setFieldsValue({
      departmentID: record.departmentID,
      expenseCatID: record.expenseCatID,
      status: record.status,
    });
    setEditingKey(record.key);
  };
  const cancel = () => {
    setEditingKey("");
  };
  const save1 = async (key) => {
    try {
      const row = await tableForm.validateFields();

      const newData = [...data];
      const index = newData.findIndex((item) => key === item.key);

      if (index > -1) {
        const item = newData[index];

        newData.splice(index, 1, {
          ...item,
          ...row,
        });
        setData(newData);
        setEditingKey("");

        const endpoint = "/pending-user-configuration/" + key;
        const method = "PUT";
        const payload = {
          departmentID: row.departmentID,
          expenseCatID: row.expenseCatID,
          status: row.status,
          historySource: "backend",
          historyAction: "Initial user configuration completed.",
          historyUserID: storeLIUId,
        };

        APICaller(
          storeRole,
          storeToken,
          endpoint,
          method,
          payload,
          storeAccessTokenExpiresOn,
        )
          .then((response) => {
            message.success("User updated successfully.");
            tableForm.resetFields();
            getUserList();
          })
          .catch((error) => {});
      } else {
        newData.push(row);
        setData(newData);
        setEditingKey("");
      }
    } catch (errInfo) {
      console.log("Validate Failed:", errInfo);
    }
  };

  const save = async (key) => {
    try {
      const row = await tableForm.validateFields();

      Modal.confirm({
        title:
          "Are you sure you want to complete the configuration for this user?",
        content: (
          <>
            <p>
              The user's information will be updated. This action cann't be
              reverted.
            </p>
          </>
        ),
        okText: "Yes, Save",
        cancelText: "Cancel",
        okButtonProps: {
          type: "primary",
        },
        onOk: async () => {
          const newData = [...data];
          const index = newData.findIndex((item) => key === item.key);

          if (index > -1) {
            const item = newData[index];

            newData.splice(index, 1, {
              ...item,
              ...row,
            });

            setData(newData);
            setEditingKey("");

            const endpoint = "/pending-user-configuration/" + key;
            const method = "PUT";

            const payload = {
              departmentID: row.departmentID,
              expenseCatID: row.expenseCatID,
              status: row.status,
              historySource: "backend",
              historyAction: "Initial user configuration completed.",
              historyUserID: storeLIUId,
            };

            try {
              await APICaller(
                storeRole,
                storeToken,
                endpoint,
                method,
                payload,
                storeAccessTokenExpiresOn,
              );

              message.success("User configuration updated successfully.");
              tableForm.resetFields();
              getUserList();
            } catch (error) {}
          } else {
            newData.push(row);
            setData(newData);
            setEditingKey("");
          }
        },
      });
    } catch (errInfo) {
      console.log("Validate Failed:", errInfo);
    }
  };
  // Filter the storeList based on the searchText
  const searchFilterData =
    storeList &&
    storeList.filter((item) => {
      const empID = item.empID ? item.empID : "";
      const name = item.name ? item.name.toLowerCase() : "";
      const email = item.email ? item.email : "";
      const department = Array.isArray(item.department)
        ? item.department.join(", ").toLowerCase()
        : (item.department || "").toLowerCase();
      const status = item.status ? item.status.toLowerCase() : "";

      return (
        empID === Number(searchText) ||
        name.includes(searchText.toLowerCase()) ||
        email.includes(searchText) ||
        department.includes(searchText.toLowerCase()) ||
        status.includes(searchText.toLowerCase())
      );
    });

  /**/
  const getExpenseCategories = () => {
    APICaller(
      storeRole,
      storeToken,
      "/expense-categories/findAll",
      "POST",
      {
        fetchWithoutPagination: "yes",
      },
      storeAccessTokenExpiresOn,
    )
      .then((response) => {
        const temp = response.response.map((item) => ({
          label: item.name,
          value: item._id,
        }));

        setExpenseCategories(temp);
      })
      .catch(() => {});
  };
  /**/
  /*begin::getDepartments will fetch the list of Departments*/
  const getDepartments = () => {
    const endpoint = "/departments/findAll";
    const method = "POST";
    const payload = {
      fetchWithoutPagination: "yes",
    };

    APICaller(
      storeRole,
      storeToken,
      endpoint,
      method,
      payload,
      storeAccessTokenExpiresOn,
    )
      .then((response) => {
        const temp = [];
        response?.response?.map((department, index) => {
          temp.push({
            label: `${department?.name} - ${department?.code}`,
            value: department?._id,
          });
        });
        sortData(temp);
        setDepartments(temp);
      })
      .catch((error) => {});
  };
  /*end::getDepartments will fetch the list of Departments*/
  useEffect(() => {
    getUserList();
    getDepartments();
    getExpenseCategories();
  }, []);

  const columns = [],
    additionalColumns = [];
  if (storeRole !== process.env.REACT_APP_SROLE) {
    columns.push({
      title: "Sr. No.",
      render: (text, record, index) => index + 1,
    });
  }
  const commonColumns = [
    {
      title: "Emp. ID",
      dataIndex: "empID",
      width: "7%",
      render: (text) => <>{text}</>,
    },
    {
      title: "Name",
      dataIndex: "name",
      width: "10%",
      render: (text) => <>{text}</>,
    },
    {
      title: "Email",
      dataIndex: "email",
      width: "15%",
      render: (text) => <>{text}</>,
    },
    {
      title: "Department",
      dataIndex: "departmentID",
      width: "10%",
      editable: true,
      render: (_, record) => record.department,
    },
    {
      title: "Expense Category",
      dataIndex: "expenseCatID",
      editable: true,
      render: (_, record) => record.expenseCategory,
    },
    {
      title: "Status",
      dataIndex: "status",
      width: "10%",
      editable: true,
      sorter: (a, b) => a.status.localeCompare(b.status),
    },
    {
      title: "Created At",
      width: "11%",
      dataIndex: "createdAt",
    },
  ];

  if (
    storeRole === process.env.REACT_APP_SROLE ||
    storeRole === process.env.REACT_APP_ADROLE
  ) {
    additionalColumns.push(
      {
        title: "Updated At",
        dataIndex: "updatedAt",
        width: "11%",
      },
      {
        title: "Action",
        dataIndex: "action",
        width: "10%",
        render: (_, record) => {
          const editable = isEditing(record);
          return editable ? (
            <span>
              <Typography.Link
                onClick={() => save(record.key)}
                style={{
                  marginRight: 8,
                }}
              >
                Save
              </Typography.Link>
              <Popconfirm title="Sure to cancel?" onConfirm={cancel}>
                <a>Cancel</a>
              </Popconfirm>
            </span>
          ) : (
            <Typography.Link
              disabled={editingKey !== ""}
              onClick={() => edit(record)}
            >
              Edit
            </Typography.Link>
          );
        },
      },
    );
  }

  columns.push(...commonColumns, ...additionalColumns);

  const mergedColumns = columns.map((col) => {
    if (!col.editable) {
      return col;
    }
    return {
      ...col,
      onCell: (record) => ({
        record,
        inputType: "text",
        dataIndex: col.dataIndex,
        title: col.title,
        editing: isEditing(record),
        departments,
        expenseCategories,
      }),
    };
  });

  const getUserList = async (source = "", pagination = "") => {
    setShowLoader(true);

    const searchIn = location.pathname.replace("/", "");
    const callActionFrom = source ? source : "";

    const allStates = {
      showLoader: showLoader,
      setShowLoader: setShowLoader,
      pagination: pagination
        ? pagination
        : { current: 1, page: 1, pageSize: 20 },
      setPagination: setPagination,
      list: list,
      setList: setList,
      fetchWithoutPagination: "yes",
    };

    await HandleSearch(
      storeRole,
      storeToken,
      storeLIUId,
      storeAccessTokenExpiresOn,
      searchIn,
      callActionFrom,
      allStates,
      "",
    );
    // Update local state after fetching data
    const fetchedData = store.getState().auth.list[currentPath + "_info"];
    //const fetchedData = data ? decryptData(data) : [];

    setStoreList(fetchedData);

    // Update data state after fetching
    setData(fetchedData);
    setShowLoader(false);
  };

  const handlePaginationChange = (page, pageSize) => {
    if (pageSize === storeTotalCount) {
      // Load all items
      getUserList("pagination", { page: 1, pageSize: storeTotalCount });
    } else {
      // Regular pagination
      getUserList("pagination", { page, pageSize });
    }
  };

  return (
    <>
      <div className="container">
        <div className="card bgi-no-repeat card-stretch gutter-b border-2 rounded-lg p-0">
          <div className="border-2 card-header p-5">
            <div className="align-items-center d-flex justify-content-between">
              <h3 className="card-title m-0 p-0 border-2 font-weight-bolder text-dark text-size-16">
                Pending User Configuration
              </h3>
            </div>
          </div>
          <div className="card-body">
            <div className="table-responsive border">
              <CustomLoader showLoader={showLoader} />
              <Search
                className="table-search"
                placeholder="Search by Employee ID, Name or Email.."
                onSearch={(value) => setSearchText(value)}
                onChange={(e) => setSearchText(e.target.value)}
              />
              <Form form={tableForm} component={false}>
                <Table
                  components={{
                    body: {
                      cell: EditableCell,
                    },
                  }}
                  bordered
                  dataSource={searchFilterData}
                  columns={mergedColumns}
                  rowClassName="editable-row"
                  pagination={{
                    current: (storePagination && storePagination?.current) || 1,
                    pageSize:
                      (storePagination && storePagination?.pageSize) || 20,
                    total: storeTotalCount,
                    pageSizeOptions: paginationOptions(storeTotalCount),
                    showSizeChanger: true,
                    onChange: (page, pageSize) =>
                      handlePaginationChange(page, pageSize),

                    onShowSizeChange: (current, size) =>
                      handlePaginationChange(current, size),
                  }}
                />
              </Form>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default PendingUserConfiguration;
